import { getDbUserId } from './multiplayUserId';

/**
 * Ensures a local `stages` row exists (POST welcomeStageStart). Use when sync has not
 * set a row id yet (e.g. race with fetchReport / admin token) so complete APIs can UPDATE.
 */
export async function ensureWelcomeStageRowId({
  backendBase,
  adminToken,
  storedUserData,
  playerName,
  user_type,
}) {
  const base = String(backendBase || "").replace(/\/+$/, "");
  const uid = getDbUserId(storedUserData);
  const sid = storedUserData?.sessionId;
  const oid = storedUserData?.organizationId;
  if (!base || !adminToken || !uid || !sid || !oid) return null;

  const startRes = await fetch(`${base}/welcomeStageStart`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${adminToken}`,
    },
    body: JSON.stringify({
      userId: uid,
      sessionId: sid,
      organizationId: oid,
      email: storedUserData.email || "",
      emp_id: storedUserData.employeeId || storedUserData.emp_id || "",
      name: typeof playerName === "string" ? playerName : "",
      user_type: user_type || "",
    }),
  });
  const startData = await startRes.json().catch(() => ({}));
  if (startRes.ok && startData.success && startData.id != null) {
    return String(startData.id);
  }
  return null;
}
